import React, { useContext } from 'react';
import { Link} from 'react-router-dom';
import { AuthContext } from '../../../Context/AuthProvider';

const Header = () => {
    const { user, logOut } = useContext(AuthContext);
    const menuItems = <>
    <li className="hover:bg-green-600 block my-4"><Link to="/">Home</Link></li>
    <li className="hover:bg-green-600 block my-4"><Link to="/blog">Blogs</Link></li>
</>;

const privateMenuItems = <>
    <li className="hover:bg-green-600 block my-4"><Link to="/">Home</Link></li>
    <li className="hover:bg-green-600 block my-4"><Link to="/blog">Blog</Link></li>
    <li className="hover:bg-green-600 block my-4"><Link to="/dashboard">Dashboard</Link></li>
</>;
    const handleLogOut = () => {
        logOut();
    }
    return (
        <div className="navbar bg-black text-white py-4 z-50 relative">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-black rounded-box w-52">
                        {
                            user?.email ?
                                <>{privateMenuItems}</>
                                :
                                <>{menuItems}</>
                        }
                    </ul>
                </div>
                <p className="btn btn-ghost normal-case text-xl">FourWheeler</p>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    {
                        user?.email ?
                            <>{privateMenuItems}</>
                            :
                            <>{menuItems}</>
                    }
                </ul>
            </div>
            <div className="navbar-end">
                {
                    user?.email ?
                        <><Link onClick={handleLogOut} className='btn'>logout</Link></>
                        :
                        <><Link to='/login' className='btn'>login</Link></>

                }
            </div>
        </div>
    );
};

export default Header;